/**
 * Names the metric in the store selector option label, where nothing else can: the selector has no
 * column header and no popup, so a bare number would not say what it is.
 *
 * Kept out of formatStoreLabel deliberately - every other consumer of that formatter wants the
 * plain label.
 *
 * @param label the already-formatted store label
 * @param storeDecile the store's decile, absent for a store the ranking has not covered
 */
export const appendStoreDecile = (label: string, storeDecile?: number | null): string =>
  typeof storeDecile === 'number' ? `${label} (Decile ${storeDecile})` : label;
